import { MarkierungType } from '@/domain/dienstplan/shared/types/Markierung';
import { Weekday } from '@/domain/dienstplan/shared/types/Weekday';
import { getColorsForMarkierung } from '@/domain/dienstplan/shared/utils/getColorForMarkierung';
export type Arbeitsbereich = {
  id: string;
  name: string;
  markierung: MarkierungType;
  belegungen?: Belegung[];
};

export class Belegung {
  constructor({
    id,
    tag,
    start,
    ende,
    personenanzahlMax,
    personenanzahlMin,
    arbeitsbereich,
  }: {
    id: string;
    tag: Weekday;
    start: number;
    ende: number;
    personenanzahlMax: number;
    personenanzahlMin: number;
    arbeitsbereich: Arbeitsbereich;
  }) {
    this.id = id;
    this.tag = tag;
    this.start = start;
    this.ende = ende;
    this.personenanzahlMax = personenanzahlMax;
    this.personenanzahlMin = personenanzahlMin;
    this.arbeitsbereich = arbeitsbereich;
  }

  id: string;
  tag: Weekday;
  start: number;
  ende: number;
  personenanzahlMax: number;
  personenanzahlMin: number;
  arbeitsbereich: Arbeitsbereich;
}

export class BelegungsIntervall {
  constructor(belegung: Belegung, mode: BelegungsIntervalMode = 'inactive') {
    this.belegung = belegung;
    this.mode = mode;
  }
  belegung: Belegung;
  mode: BelegungsIntervalMode;
  get startX(): number {
    return Math.round(this.belegung.start / 0.25) * 0.25;
  }

  get endeX(): number {
    return Math.round(this.belegung.ende / 0.25) * 0.25;
  }

  get startY(): number {
    return this.belegung.personenanzahlMax;
  }

  get width(): number {
    if (this.belegung.ende === 0) {
      return 24 - this.belegung.start;
    }
    return this.belegung.ende - this.belegung.start;
  }
  get height(): number {
    return this.belegung.personenanzahlMax - this.belegung.personenanzahlMin;
  }

  get fillColor(): string {
    return getColorsForMarkierung(this.belegung.arbeitsbereich.markierung)
      .light;
  }
  get borderColor(): string {
    return getColorsForMarkierung(this.belegung.arbeitsbereich.markierung).base;
  }
}

type BelegungsIntervalMode =
  | 'create'
  | 'inactive'
  | 'active'
  | 'resize'
  | 'resize-height';
